import apiClient from '../http/apiClient';

/**
 * Public, unauthenticated login-brand lookup.
 *
 * `GET /api/v1/workspaces/<uuid>/login-brand/` returns the brand a specific
 * workspace wants shown on the PRE-auth login/auth screens (before the viewer
 * has a session, so it can't come from `me/summary`). Shape:
 *
 *   {
 *     name: string,
 *     logo_url: string,          // '' when the workspace has no logo
 *     primary: string,           // space-separated RGB channels, e.g. "86 133 188"
 *     secondary: string,         // same channel format as --primary/--secondary
 *     branded: boolean           // false => show the Octopus default, unchanged
 *   }
 *
 * `branded: false` (unknown / unthemed / not-opted-in) all mean "leave the
 * default Octopus login alone" — the caller must not apply anything.
 */
export type LoginBrand = {
  name: string;
  logo_url: string;
  primary: string;
  secondary: string;
  branded: boolean;
};

export const getLoginBrand = (workspaceId: string): Promise<LoginBrand> =>
  apiClient
    .get<LoginBrand>(`/workspaces/${workspaceId}/login-brand/`, {
      // Pre-auth call — never attach a stale Authorization header.
      headers: { Authorization: '' }
    })
    .then((response) => response.data);
